declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    omnisend?: unknown[]
  }
}

export default defineNuxtPlugin(() => {
  if (useAppEnv().isTesting) return
  const { tracking } = useSettings()
  const router = useRouter()
  const marketingCookies = useCookie('marketing_cookies', CONSENT_COOKIE_OPTS)

  if (tracking?.facebookPixelId) {
    const pixelId = tracking.facebookPixelId

    watch(marketingCookies, (val) => {
      if (val !== '1' || window.fbq) return

      useHead({
        script: [{ key: 'fb-pixel', src: 'https://connect.facebook.net/en_US/fbevents.js', async: true }],
      })

      const fbq: any = function (...args: unknown[]) {
        fbq.callMethod
          ? fbq.callMethod.apply(fbq, args)
          : fbq.queue.push(args)
      }
      fbq.push = fbq
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.queue = []
      window.fbq = fbq

      fbq('init', pixelId)
      fbq('track', 'PageView')
    }, { immediate: true })

    router.afterEach(() => {
      if (marketingCookies.value === '1' && window.fbq) {
        window.fbq('track', 'PageView')
      }
    })
  }

  if (tracking?.omnisendAccountId) {
    const accountId = tracking.omnisendAccountId

    watch(marketingCookies, (val) => {
      const omni = window.omnisend as (unknown[] & { _loaded?: boolean }) | undefined
      if (val !== '1' || omni?._loaded) return

      window.omnisend = window.omnisend || []
      window.omnisend.push(['accountID', accountId])
      window.omnisend.push(['track', '$pageViewed'])

      useHead({
        script: [{ key: 'omnisend', src: 'https://omnisnippet1.com/inshop/launcher-v2.js', async: true }],
      })

      ;(window.omnisend as unknown[] & { _loaded?: boolean })._loaded = true
    }, { immediate: true })

    router.afterEach(() => {
      if (marketingCookies.value === '1' && window.omnisend) {
        window.omnisend.push(['track', '$pageViewed'])
      }
    })
  }
})
